export default "__VITE_ASSET__CF_k8Aox__"